import React from "react"

export default function Game(props) {


    let i = 0;
    let y = 0;
    let z = 0;

    return (

        <div>
            {/* mobile block */}
            {props.device === "mobile" ?

                <div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">

                        {props.data ? (props.data.map(game => (
                            ((i < 4) ?
                                <div key={i++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : null)
                        )))
                            : null
                        }
                    </div>

                    <div className="text-center">
                        {props.adsMobile}
                    </div>


                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (

                            ((y > 3 && y < 14) ?
                                <div key={y++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : <div key={y++} className="hidden"></div>)

                        )))
                            : null
                        }
                    </div>

                    <div className="text-center">
                        {props.adsMobile2}
                    </div>


                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (

                            ((z > 13 && z < 30) ?
                                <div key={y++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : <div key={z++} className="hidden"></div>)

                        )))
                            : null
                        }
                    </div>
                </div>
                : null}

            {/* Tablet block */}
            {props.device === "tablet" ?


                <div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((i < 6) ?
                                <div key={i++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : null)
                        )))
                            : null
                        }
                    </div>

                    <div className="text-center">
                        {props.adsMobile}
                    </div>


                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((y > 5 && y < 21) ?
                                <div key={y++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : <div key={y++} className="hidden"></div>)

                        )))
                            : null
                        }
                    </div>

                    <div className="text-center">
                        {props.adsMobile2}
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((z > 20 && z < 60) ?
                                <div key={y++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : <div key={z++} className="hidden"></div>)
                        )))
                            : null
                        }
                    </div>
                </div>
                : null}


            {/* desktop xl */}

            {props.device === "desktopxl" ?

                <div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((i < 20) ?
                                <div key={i++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : null)
                        )))
                            : null
                        }
                    </div>

                    <div className="text-center">
                        {props.adsDesktop}
                    </div>


                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((y > 20) ?
                                <div key={y++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : <div key={y++} className="hidden"></div>)

                        )))
                            : null
                        }


                    </div>
                </div>

                : null}


            {/* desktop 2xl */}

            {props.device === "desktop2xl" ?


                <div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((i < 30) ?
                                <div key={i++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : null)
                        )))
                            : null
                        }
                    </div>

                    <div className="text-center">
                        {props.adsDesktop}
                    </div>


                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                        {props.data ? (props.data.map(game => (
                            ((y > 20) ?
                                <div key={y++}>
                                    <a href={`/play/?game=${game.title}`}>
                                        <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                            <div>
                                                <div>
                                                    <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                                    <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                : <div key={y++} className="hidden"></div>)

                        )))
                            : null
                        }

                    </div>
                </div>
                : null}

            {/* test */}
            {/* {props.device === "desktop" ?
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-6 gap-1 bg-grey">
                    {props.data ? (props.data.map(game => (
                        <div key={i++}>
                            <a href={`/play/?game=${game.title}`}>
                                <div className="relative cursor-pointer flex border border-greyB mx-4 my-2 bg-tileBackgroud rounded w-[90%] max-w-[300px]" >
                                    <div>
                                        <div>
                                            <div className="p-1.5"><img src={game.teaser} alt="Images" /></div>
                                            <div><p className="text-center mb-4 h-[50px]">{game.title}</p></div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    )))
                        : null
                    }



                </div>
                : null} */}






        </div>
    )
}
